import { Post } from "@/models/post";
import { Pagination } from "@/models/pagination";
import { IPost, PostState } from "@/types/post";
import { GeneralMutationTree } from "../generalMutation";

const mutations: GeneralMutationTree<PostState, IPost> = {
  single: (state, single) => {
    state.single = new Post(single);
  },
  pagination: (state, pagination) => {
    pagination.data = pagination.data.map((item) => new Post(item));
    state.pagination = new Pagination(pagination);
  },
  clear: (state) => {
    state.single = new Post();
    state.pagination = new Pagination();
  },
};

export default mutations;
